import React from 'react';

import loadable from '@loadable/component';

import withPageComponents from '../../page/components/with-page-components';
import useTestFlags from '../../abtest/useTestFlags';
import { Helpers } from '../../core/src/helpers';

const AEMBanner = loadable(() => Helpers.retryFunc(() => import('./aemBanner')));

function AEMBannerContainer({ aemBanner, finderResults, device, location, analyticsData }) {
    const { contentList: banners, viewAll } = aemBanner || {};
    const { diableContentFragments } = finderResults || {};
    const { aemContentFragment } = useTestFlags(['aemContentFragment']);
    const { disableAEM = diableContentFragments } = aemContentFragment || {};

    const category = analyticsData?.product_type || '';

    if (!banners || banners.length === 0 || disableAEM) {
        return null;
    }

    return (
        <div className="aemBanner-container">
            <AEMBanner banners={banners} viewAll={viewAll} device={device} location={location} category={category} />
        </div>
    );
}

export default withPageComponents(AEMBannerContainer, {
    components: ['aemBanner', 'finderResults'],
    device: true,
    location: true,
    analyticsData: true,
});
